import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificado-curso-herramientas-office',
  templateUrl: './certificado-curso-herramientas-office.component.html',
  styleUrls: ['./certificado-curso-herramientas-office.component.scss']
})
export class CertificadoCursoHerramientasOfficeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
